type StatusColor = "green" | "red" | "orange" | "gray" | "blue";

export const BroadcastStatus = {
  Scheduled: 1,
  Sending: 2,
  Completed: 3,
  Failed: 4,
  Canceled: 5
} as const;

export const broadcastStatusLabel = (status: number): string => {
  switch (status) {
    case BroadcastStatus.Scheduled:
      return "E planifikuar";
    case BroadcastStatus.Sending:
      return "Duke u dërguar";
    case BroadcastStatus.Completed:
      return "E dërguar";
    case BroadcastStatus.Failed:
      return "Dështoi";
    case BroadcastStatus.Canceled:
      return "E anuluar";
    default:
      return "E panjohur";
  }
};

export const broadcastStatusColor = (status: number): StatusColor => {
  switch (status) {
    case BroadcastStatus.Scheduled:
      return "blue";
    case BroadcastStatus.Sending:
      return "orange";
    case BroadcastStatus.Completed:
      return "green";
    case BroadcastStatus.Failed:
      return "red";
    case BroadcastStatus.Canceled:
    default:
      return "gray";
  }
};

// Languages the mobile app ships with (PushDevice.ApplicationLanguage codes).
export const appLanguages: { code: string; label: string }[] = [
  { code: "en", label: "Anglisht" },
  { code: "sq", label: "Shqip" },
  { code: "mk", label: "Maqedonisht" },
  { code: "de", label: "Gjermanisht" },
  { code: "fr", label: "Frëngjisht" },
  { code: "es", label: "Spanjisht" },
  { code: "tr", label: "Turqisht" },
  { code: "pl", label: "Polonisht" },
  { code: "it", label: "Italisht" },
  { code: "pt", label: "Portugalisht" },
  { code: "hr", label: "Kroatisht" }
];

// Backend/DB limits: BroadcastNotificationMessages.Title nvarchar(200), .Body nvarchar(2000).
// Shared by the form's yup schema and the translation merge so the numbers have one source.
export const BROADCAST_TITLE_MAX = 200;
export const BROADCAST_BODY_MAX = 2000;

export const appLanguageLabel = (code?: string | null): string => {
  if (!code) return "Të gjitha";
  const found = appLanguages.find((l) => l.code === code);
  return found ? found.label : code;
};

// Joins codes into a readable Albanian list for toasts and result summaries, so a failure
// report reads "Gjermanisht, Polonisht" rather than "de, pl".
// The language admins compose the main message in. Only the generate flow reads it — it is never
// submitted, and it is the one language excluded from generation.
export const DEFAULT_BROADCAST_SOURCE_LANGUAGE = "en";

export const appLanguageLabels = (codes: string[]): string =>
  (codes || []).map((code) => appLanguageLabel(code)).join(", ");

// Screens the app can open when a notification is tapped (expo-router paths
// read from the push payload's "route" key by useNotificationNavigation).
export const appRoutes: { path: string; label: string }[] = [
  { path: "/", label: "Kryefaqja (dyqani i paketave)" },
  { path: "/my-esims", label: "eSIM-et e mia" },
  { path: "/notifications", label: "Njoftimet" },
  { path: "/games", label: "Lojërat" },
  { path: "/games/leaderboard", label: "Renditja e lojërave" },
  { path: "/referral-code", label: "Kodi i ftesës" },
  { path: "/profile", label: "Profili" },
  { path: "/profile/loyalty", label: "Besnikëria" },
  { path: "/profile/gifts", label: "Dhuratat" }
];

export const appRouteLabel = (path?: string | null): string => {
  if (!path) return "Vetëm hap aplikacionin";
  const found = appRoutes.find((r) => r.path === path);
  return found ? `${found.label} (${path})` : path;
};
